import { cacheCheckIsHKWallet } from '@/business/wallet-area';
import { to } from '@tencent/wphk-base-utils';
import { onMounted, ref } from 'vue';
export const useDefaultHK = () => {
  const isDefaultHk = ref(true);
  onMounted(async () => {
    const [, res] = await to(cacheCheckIsHKWallet());
    isDefaultHk.value = !!res;
  });
  return { isDefaultHk };
};
